import React from "react";
import { IconInfoCircle } from "@tabler/icons";

interface InfoButtonProps {
  onClick?: () => void;
  color?: string;
  size?: number;
}

const InfoButton: React.FC<InfoButtonProps> = ({
  onClick,
  color = "#EF7C01",
  size = 20,
}) => {
  return (
    <div
      onClick={onClick}
      style={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
        color,
        marginLeft: "4px",
        width: size,
        height: size,
      }}
    >
      <IconInfoCircle size={size} color={color} />
    </div>
  );
};

export default InfoButton;
